import React from "react";
import PropTypes from "prop-types";
//import material-ui components
import withStyles from "@material-ui/core/styles/withStyles"
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
//import material icons
import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";
//import core components
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput";

import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

class ConfirmDeleteUserDialog extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            name: "",
            username: "",
            password: "",
            email: "",
            role: "",
            isActive: true,
            organizationId: null,
        };
    }

    componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.userData && !nextProps.userData.isNew
                && nextProps.isOpened && !this.props.isOpened){
            this.setState({
                ...nextProps.userData,
                password: "",
            })
        }
        if (!nextProps.isOpened){
            this.setState({
                name: "",
                username: "",
                password: "",
                role: "",
                isActive: true,
                organizationId: null,
            })
        }
    }

    _changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state)
    }

    _changeCheckerHandler(e, type) {
        this.setState((prevState) => ({
            ...prevState,
            [type]: !prevState[type],
        }))
    }

    render(){
        const { classes, onCancel, onSave, isOpened, isNew} = this.props;
        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                open={isOpened}
                onClose={() => onCancel()}
            >
                <DialogTitle
                    disableTypography
                    className={classes.modalHeader}
                >
                    <IconButton
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={() => onCancel()}
                    >
                        <Close className={classes.modalClose} />
                    </IconButton>
                    <h4 className={classes.modalTitle} >{isNew ? "Создание нового" : "Редактирование" } пользователя</h4>
                </DialogTitle>
                <DialogContent className={classes.modalBody}>
                    <Grid container>
                        <GridItem xs={12} md={6}>
                            <CustomInput
                                labelText="Логин"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.username,
                                    onChange: e => this._changeValue(e, "username")
                                }}
                            />
                            <CustomInput
                                labelText="Имя пользователя"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.name,
                                    onChange: e => this._changeValue(e, "name")
                                }}
                            />
                            <CustomInput
                                labelText="E-mail"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.email,
                                    onChange: e => this._changeValue(e, "email")
                                }}
                            />
                        </GridItem>
                        <GridItem xs={12} md={6}>
                            <CustomInput
                                labelText="Пароль"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    type:"password",
                                    onChange: e => this._changeValue(e, "password")
                                }}
                                helperText={ isNew ? "" : "Оставьте это поле пустым, если не хотите изменять пароль."}
                            />
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel>Роль</InputLabel>
                                <Select
                                    value={this.state.role}
                                    onChange={(e) => this._changeValue(e, "role")}
                                    inputProps={{
                                        name: 'role',
                                    }}
                                    className={classes.select}
                                >
                                    {this.props.roles.map((role, key) => (
                                        <MenuItem value={role} key={key}>{role}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.selectWrapper} disabled={!this.props.organizationEditable}>
                                <InputLabel>Организация</InputLabel>
                                <Select
                                    value={this.state.organizationId}
                                    onChange={(e) => this._changeValue(e, "organizationId")}
                                    inputProps={{
                                        name: 'role',
                                    }}
                                    className={classes.select}
                                >
                                    <MenuItem value=""><em>По умолчанию</em></MenuItem>
                                    {this.props.organizations.map((org, key) => (
                                        <MenuItem value={org.id} key={key}>{org.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.isActive}
                                        checkedIcon={<Check className={classes.checkedIcon} />}
                                        icon={<Check className={classes.uncheckedIcon} />}
                                        classes={{ checked: classes.checked }}
                                        onChange={(e) => this._changeCheckerHandler(e, "isActive")}
                                    />
                                }
                                classes={{ label: classes.label }}
                                label="Активен"
                            />
                        </GridItem>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.modalFooter} >
                    <Button color="primary"
                            onClick={() => onSave(this.state)}
                    >
                        Сохранить
                    </Button>
                    <Button color="primary" simple
                            onClick={() => onCancel()}
                    >
                        Отменить
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

ConfirmDeleteUserDialog.propTypes = {
    isOpened: PropTypes.bool,
    isNew: PropTypes.bool,
    userData: PropTypes.object,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
    user: PropTypes.number,
    roles: PropTypes.arrayOf(PropTypes.string),
    organizations: PropTypes.array,
    organizationEditable: PropTypes.bool,
};

export default withStyles(modalStyle)(ConfirmDeleteUserDialog);


// WEBPACK FOOTER //
// ./src/components/Dialogs/UserDialog.jsx